var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 1.98438V4.25H17.0781V1.98438V0.625H19.7969V1.98438V4.25H25.6875V8.78125V11.5V26.9062V29.625H22.9688H3.03125H0.3125V26.9062V11.5V8.78125V4.25H6.20312V1.98438V0.625H8.92188V1.98438ZM3.03125 11.5V26.9062H22.9688V11.5H3.03125ZM14.3594 13.7656V15.125V17.8438H17.0781H18.4375V20.5625H17.0781H14.3594V23.2812V24.6406H11.6406V23.2812V20.5625H8.92188H7.5625V17.8438H8.92188H11.6406V15.125V13.7656H14.3594Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlus);
export default __webpack_public_path__ + "static/media/calendar-plus.6dd78661555a0807a5da6c99c2578a68.svg";
export { ForwardRef as ReactComponent };